// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file billing/v1/service.proto (package billing.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Account, AccountJson, Contact, ContactJson, EntityAccount, EntityAccountJson, EntityAccountType, EntityAccountTypeJson, FeatureType, FeatureTypeJson, PaymentMethod, PaymentMethodJson, Subscription, SubscriptionJson, SubscriptionStatus, SubscriptionStatusJson, UsageRecord, UsageRecordJson } from "./billing_pb";
import { file_billing_v1_billing } from "./billing_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date, DateJson } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file billing/v1/service.proto.
 */
export const file_billing_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_billing_v1_billing, file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_timestamp, file_google_type_date],
	);

/**
 * CreateAccountRequest is the request to create an account
 *
 * @generated from message billing.v1.CreateAccountRequest
 */
export type CreateAccountRequest = Message<"billing.v1.CreateAccountRequest"> & {
	/**
	 * @generated from field: string entity_id = 1;
	 */
	entityId: string;

	/**
	 * @generated from field: billing.v1.EntityAccountType entity_type = 2;
	 */
	entityType: EntityAccountType;

	/**
	 * @generated from field: string name = 3;
	 */
	name: string;

	/**
	 * @generated from field: string pod = 4;
	 */
	pod: string;

	/**
	 * @generated from field: string sales_channel = 5;
	 */
	salesChannel: string;

	/**
	 * @generated from field: string vertical = 6;
	 */
	vertical: string;

	/**
	 * @generated from field: string csm = 7;
	 */
	csm: string;

	/**
	 * @generated from field: bool auto_pay = 8;
	 */
	autoPay: boolean;

	/**
	 * @generated from field: int64 billing_cycle_day = 9;
	 */
	billingCycleDay: bigint;

	/**
	 * @generated from field: billing.v1.Contact bill_to_contact = 10;
	 */
	billToContact?: Contact;

	/**
	 * @generated from field: string parent_provider_account_id = 11;
	 */
	parentProviderAccountId: string;

	/**
	 * @generated from field: optional billing.v1.Contact sold_to_contact = 12;
	 */
	soldToContact?: Contact;

	/**
	 * @generated from field: optional bool skip_save_to_entity_account = 13;
	 */
	skipSaveToEntityAccount?: boolean;

	/**
	 * @generated from field: repeated string additional_email_addresses = 14;
	 */
	additionalEmailAddresses: string[];
};

/**
 * CreateAccountRequest is the request to create an account
 *
 * @generated from message billing.v1.CreateAccountRequest
 */
export type CreateAccountRequestJson = {
	/**
	 * @generated from field: string entity_id = 1;
	 */
	entityId?: string;

	/**
	 * @generated from field: billing.v1.EntityAccountType entity_type = 2;
	 */
	entityType?: EntityAccountTypeJson;

	/**
	 * @generated from field: string name = 3;
	 */
	name?: string;

	/**
	 * @generated from field: string pod = 4;
	 */
	pod?: string;

	/**
	 * @generated from field: string sales_channel = 5;
	 */
	salesChannel?: string;

	/**
	 * @generated from field: string vertical = 6;
	 */
	vertical?: string;

	/**
	 * @generated from field: string csm = 7;
	 */
	csm?: string;

	/**
	 * @generated from field: bool auto_pay = 8;
	 */
	autoPay?: boolean;

	/**
	 * @generated from field: int64 billing_cycle_day = 9;
	 */
	billingCycleDay?: string;

	/**
	 * @generated from field: billing.v1.Contact bill_to_contact = 10;
	 */
	billToContact?: ContactJson;

	/**
	 * @generated from field: string parent_provider_account_id = 11;
	 */
	parentProviderAccountId?: string;

	/**
	 * @generated from field: optional billing.v1.Contact sold_to_contact = 12;
	 */
	soldToContact?: ContactJson;

	/**
	 * @generated from field: optional bool skip_save_to_entity_account = 13;
	 */
	skipSaveToEntityAccount?: boolean;

	/**
	 * @generated from field: repeated string additional_email_addresses = 14;
	 */
	additionalEmailAddresses?: string[];
};

/**
 * Describes the message billing.v1.CreateAccountRequest.
 * Use `create(CreateAccountRequestSchema)` to create a new message.
 */
export const CreateAccountRequestSchema: GenMessage<CreateAccountRequest, { jsonType: CreateAccountRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 0);

/**
 * CreateAccountResponse is the response to create an account
 *
 * @generated from message billing.v1.CreateAccountResponse
 */
export type CreateAccountResponse = Message<"billing.v1.CreateAccountResponse"> & {
	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId: string;

	/**
	 * @generated from field: string provider_account_number = 2;
	 */
	providerAccountNumber: string;
};

/**
 * CreateAccountResponse is the response to create an account
 *
 * @generated from message billing.v1.CreateAccountResponse
 */
export type CreateAccountResponseJson = {
	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId?: string;

	/**
	 * @generated from field: string provider_account_number = 2;
	 */
	providerAccountNumber?: string;
};

/**
 * Describes the message billing.v1.CreateAccountResponse.
 * Use `create(CreateAccountResponseSchema)` to create a new message.
 */
export const CreateAccountResponseSchema: GenMessage<CreateAccountResponse, { jsonType: CreateAccountResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 1);

/**
 * ListAccountsRequest is the request to list accounts with filtering
 *
 * @generated from message billing.v1.ListAccountsRequest
 */
export type ListAccountsRequest = Message<"billing.v1.ListAccountsRequest"> & {
	/**
	 * The filter to apply to the list of accounts
	 *
	 * @generated from field: repeated billing.v1.AccountSearchFilter filters = 1;
	 */
	filters: AccountSearchFilter[];

	/**
	 * The pagination arguments
	 *
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments;
};

/**
 * ListAccountsRequest is the request to list accounts with filtering
 *
 * @generated from message billing.v1.ListAccountsRequest
 */
export type ListAccountsRequestJson = {
	/**
	 * The filter to apply to the list of accounts
	 *
	 * @generated from field: repeated billing.v1.AccountSearchFilter filters = 1;
	 */
	filters?: AccountSearchFilterJson[];

	/**
	 * The pagination arguments
	 *
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message billing.v1.ListAccountsRequest.
 * Use `create(ListAccountsRequestSchema)` to create a new message.
 */
export const ListAccountsRequestSchema: GenMessage<ListAccountsRequest, { jsonType: ListAccountsRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 2);

/**
 * ListAccountsResponse is the response to list accounts
 *
 * @generated from message billing.v1.ListAccountsResponse
 */
export type ListAccountsResponse = Message<"billing.v1.ListAccountsResponse"> & {
	/**
	 * The accounts that were retrieved
	 *
	 * @generated from field: repeated billing.v1.Account accounts = 1;
	 */
	accounts: Account[];

	/**
	 * The pagination page info
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * ListAccountsResponse is the response to list accounts
 *
 * @generated from message billing.v1.ListAccountsResponse
 */
export type ListAccountsResponseJson = {
	/**
	 * The accounts that were retrieved
	 *
	 * @generated from field: repeated billing.v1.Account accounts = 1;
	 */
	accounts?: AccountJson[];

	/**
	 * The pagination page info
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message billing.v1.ListAccountsResponse.
 * Use `create(ListAccountsResponseSchema)` to create a new message.
 */
export const ListAccountsResponseSchema: GenMessage<ListAccountsResponse, { jsonType: ListAccountsResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 3);

/**
 * @generated from message billing.v1.AccountSearchFilter
 */
export type AccountSearchFilter = Message<"billing.v1.AccountSearchFilter"> & {
	/**
	 * @generated from field: billing.v1.AccountSearchField field_name = 1;
	 */
	fieldName: AccountSearchField;

	/**
	 * @generated from field: string field_value = 2;
	 */
	fieldValue: string;

	/**
	 * @generated from field: billing.v1.FilterOperator operator = 3;
	 */
	operator: FilterOperator;
};

/**
 * @generated from message billing.v1.AccountSearchFilter
 */
export type AccountSearchFilterJson = {
	/**
	 * @generated from field: billing.v1.AccountSearchField field_name = 1;
	 */
	fieldName?: AccountSearchFieldJson;

	/**
	 * @generated from field: string field_value = 2;
	 */
	fieldValue?: string;

	/**
	 * @generated from field: billing.v1.FilterOperator operator = 3;
	 */
	operator?: FilterOperatorJson;
};

/**
 * Describes the message billing.v1.AccountSearchFilter.
 * Use `create(AccountSearchFilterSchema)` to create a new message.
 */
export const AccountSearchFilterSchema: GenMessage<AccountSearchFilter, { jsonType: AccountSearchFilterJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 4);

/**
 * GetAccountRequest is the request to get an account
 *
 * @generated from message billing.v1.GetAccountRequest
 */
export type GetAccountRequest = Message<"billing.v1.GetAccountRequest"> & {
	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId: string;
};

/**
 * GetAccountRequest is the request to get an account
 *
 * @generated from message billing.v1.GetAccountRequest
 */
export type GetAccountRequestJson = {
	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId?: string;
};

/**
 * Describes the message billing.v1.GetAccountRequest.
 * Use `create(GetAccountRequestSchema)` to create a new message.
 */
export const GetAccountRequestSchema: GenMessage<GetAccountRequest, { jsonType: GetAccountRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 5);

/**
 * GetAccountResponse is the response to get an account
 *
 * @generated from message billing.v1.GetAccountResponse
 */
export type GetAccountResponse = Message<"billing.v1.GetAccountResponse"> & {
	/**
	 * The account that was retrieved
	 *
	 * @generated from field: billing.v1.Account account = 1;
	 */
	account?: Account;
};

/**
 * GetAccountResponse is the response to get an account
 *
 * @generated from message billing.v1.GetAccountResponse
 */
export type GetAccountResponseJson = {
	/**
	 * The account that was retrieved
	 *
	 * @generated from field: billing.v1.Account account = 1;
	 */
	account?: AccountJson;
};

/**
 * Describes the message billing.v1.GetAccountResponse.
 * Use `create(GetAccountResponseSchema)` to create a new message.
 */
export const GetAccountResponseSchema: GenMessage<GetAccountResponse, { jsonType: GetAccountResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 6);

/**
 * @generated from message billing.v1.ListSubscriptionsByAccountRequest
 */
export type ListSubscriptionsByAccountRequest = Message<"billing.v1.ListSubscriptionsByAccountRequest"> & {
	/**
	 * The ID of the account to get subscriptions for
	 *
	 * @generated from field: string provider_account_key = 1;
	 */
	providerAccountKey: string;

	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments;
};

/**
 * @generated from message billing.v1.ListSubscriptionsByAccountRequest
 */
export type ListSubscriptionsByAccountRequestJson = {
	/**
	 * The ID of the account to get subscriptions for
	 *
	 * @generated from field: string provider_account_key = 1;
	 */
	providerAccountKey?: string;

	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message billing.v1.ListSubscriptionsByAccountRequest.
 * Use `create(ListSubscriptionsByAccountRequestSchema)` to create a new message.
 */
export const ListSubscriptionsByAccountRequestSchema: GenMessage<ListSubscriptionsByAccountRequest, { jsonType: ListSubscriptionsByAccountRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 7);

/**
 * @generated from message billing.v1.ListSubscriptionsByAccountResponse
 */
export type ListSubscriptionsByAccountResponse = Message<"billing.v1.ListSubscriptionsByAccountResponse"> & {
	/**
	 * The subscriptions that were retrieved
	 *
	 * @generated from field: repeated billing.v1.Subscription subscriptions = 1;
	 */
	subscriptions: Subscription[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message billing.v1.ListSubscriptionsByAccountResponse
 */
export type ListSubscriptionsByAccountResponseJson = {
	/**
	 * The subscriptions that were retrieved
	 *
	 * @generated from field: repeated billing.v1.Subscription subscriptions = 1;
	 */
	subscriptions?: SubscriptionJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message billing.v1.ListSubscriptionsByAccountResponse.
 * Use `create(ListSubscriptionsByAccountResponseSchema)` to create a new message.
 */
export const ListSubscriptionsByAccountResponseSchema: GenMessage<ListSubscriptionsByAccountResponse, { jsonType: ListSubscriptionsByAccountResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 8);

/**
 * @generated from message billing.v1.ListSubscriptionsRequest
 */
export type ListSubscriptionsRequest = Message<"billing.v1.ListSubscriptionsRequest"> & {
	/**
	 * The entity account id of the account to get subscriptions for
	 *
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;

	/**
	 * The pagination arguments
	 *
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments;
};

/**
 * @generated from message billing.v1.ListSubscriptionsRequest
 */
export type ListSubscriptionsRequestJson = {
	/**
	 * The entity account id of the account to get subscriptions for
	 *
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;

	/**
	 * The pagination arguments
	 *
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message billing.v1.ListSubscriptionsRequest.
 * Use `create(ListSubscriptionsRequestSchema)` to create a new message.
 */
export const ListSubscriptionsRequestSchema: GenMessage<ListSubscriptionsRequest, { jsonType: ListSubscriptionsRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 9);

/**
 * @generated from message billing.v1.ListSubscriptionsResponse
 */
export type ListSubscriptionsResponse = Message<"billing.v1.ListSubscriptionsResponse"> & {
	/**
	 * The subscriptions that were retrieved
	 *
	 * @generated from field: repeated billing.v1.Subscription subscriptions = 1;
	 */
	subscriptions: Subscription[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message billing.v1.ListSubscriptionsResponse
 */
export type ListSubscriptionsResponseJson = {
	/**
	 * The subscriptions that were retrieved
	 *
	 * @generated from field: repeated billing.v1.Subscription subscriptions = 1;
	 */
	subscriptions?: SubscriptionJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message billing.v1.ListSubscriptionsResponse.
 * Use `create(ListSubscriptionsResponseSchema)` to create a new message.
 */
export const ListSubscriptionsResponseSchema: GenMessage<ListSubscriptionsResponse, { jsonType: ListSubscriptionsResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 10);

/**
 * @generated from message billing.v1.GetCurrentSubscriptionRequest
 */
export type GetCurrentSubscriptionRequest = Message<"billing.v1.GetCurrentSubscriptionRequest"> & {
	/**
	 * The entity account id of the account get the current subscription for
	 *
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;
};

/**
 * @generated from message billing.v1.GetCurrentSubscriptionRequest
 */
export type GetCurrentSubscriptionRequestJson = {
	/**
	 * The entity account id of the account get the current subscription for
	 *
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;
};

/**
 * Describes the message billing.v1.GetCurrentSubscriptionRequest.
 * Use `create(GetCurrentSubscriptionRequestSchema)` to create a new message.
 */
export const GetCurrentSubscriptionRequestSchema: GenMessage<GetCurrentSubscriptionRequest, { jsonType: GetCurrentSubscriptionRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 11);

/**
 * @generated from message billing.v1.GetCurrentSubscriptionResponse
 */
export type GetCurrentSubscriptionResponse = Message<"billing.v1.GetCurrentSubscriptionResponse"> & {
	/**
	 * The subscription that was retrieved
	 *
	 * @generated from field: billing.v1.Subscription subscription = 1;
	 */
	subscription?: Subscription;
};

/**
 * @generated from message billing.v1.GetCurrentSubscriptionResponse
 */
export type GetCurrentSubscriptionResponseJson = {
	/**
	 * The subscription that was retrieved
	 *
	 * @generated from field: billing.v1.Subscription subscription = 1;
	 */
	subscription?: SubscriptionJson;
};

/**
 * Describes the message billing.v1.GetCurrentSubscriptionResponse.
 * Use `create(GetCurrentSubscriptionResponseSchema)` to create a new message.
 */
export const GetCurrentSubscriptionResponseSchema: GenMessage<GetCurrentSubscriptionResponse, { jsonType: GetCurrentSubscriptionResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 12);

/**
 * @generated from message billing.v1.GetEntityAccountRequest
 */
export type GetEntityAccountRequest = Message<"billing.v1.GetEntityAccountRequest"> & {
	/**
	 * The type of entity account
	 *
	 * @generated from field: billing.v1.EntityAccountType entity_type = 1;
	 */
	entityType: EntityAccountType;

	/**
	 * The id of the entity account
	 *
	 * @generated from field: string entity_id = 2;
	 */
	entityId: string;
};

/**
 * @generated from message billing.v1.GetEntityAccountRequest
 */
export type GetEntityAccountRequestJson = {
	/**
	 * The type of entity account
	 *
	 * @generated from field: billing.v1.EntityAccountType entity_type = 1;
	 */
	entityType?: EntityAccountTypeJson;

	/**
	 * The id of the entity account
	 *
	 * @generated from field: string entity_id = 2;
	 */
	entityId?: string;
};

/**
 * Describes the message billing.v1.GetEntityAccountRequest.
 * Use `create(GetEntityAccountRequestSchema)` to create a new message.
 */
export const GetEntityAccountRequestSchema: GenMessage<GetEntityAccountRequest, { jsonType: GetEntityAccountRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 13);

/**
 * @generated from message billing.v1.GetEntityAccountResponse
 */
export type GetEntityAccountResponse = Message<"billing.v1.GetEntityAccountResponse"> & {
	/**
	 * @generated from field: billing.v1.EntityAccount entity_account = 1;
	 */
	entityAccount?: EntityAccount;
};

/**
 * @generated from message billing.v1.GetEntityAccountResponse
 */
export type GetEntityAccountResponseJson = {
	/**
	 * @generated from field: billing.v1.EntityAccount entity_account = 1;
	 */
	entityAccount?: EntityAccountJson;
};

/**
 * Describes the message billing.v1.GetEntityAccountResponse.
 * Use `create(GetEntityAccountResponseSchema)` to create a new message.
 */
export const GetEntityAccountResponseSchema: GenMessage<GetEntityAccountResponse, { jsonType: GetEntityAccountResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 14);

/**
 * @generated from message billing.v1.CreateEntityAccountRequest
 */
export type CreateEntityAccountRequest = Message<"billing.v1.CreateEntityAccountRequest"> & {
	/**
	 * @generated from field: string entity_id = 1;
	 */
	entityId: string;

	/**
	 * @generated from field: billing.v1.EntityAccountType entity_type = 2;
	 */
	entityType: EntityAccountType;

	/**
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId: string;
};

/**
 * @generated from message billing.v1.CreateEntityAccountRequest
 */
export type CreateEntityAccountRequestJson = {
	/**
	 * @generated from field: string entity_id = 1;
	 */
	entityId?: string;

	/**
	 * @generated from field: billing.v1.EntityAccountType entity_type = 2;
	 */
	entityType?: EntityAccountTypeJson;

	/**
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId?: string;
};

/**
 * Describes the message billing.v1.CreateEntityAccountRequest.
 * Use `create(CreateEntityAccountRequestSchema)` to create a new message.
 */
export const CreateEntityAccountRequestSchema: GenMessage<CreateEntityAccountRequest, { jsonType: CreateEntityAccountRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 15);

/**
 * @generated from message billing.v1.CreateEntityAccountResponse
 */
export type CreateEntityAccountResponse = Message<"billing.v1.CreateEntityAccountResponse"> & {
	/**
	 * @generated from field: billing.v1.EntityAccount entity_account = 1;
	 */
	entityAccount?: EntityAccount;
};

/**
 * @generated from message billing.v1.CreateEntityAccountResponse
 */
export type CreateEntityAccountResponseJson = {
	/**
	 * @generated from field: billing.v1.EntityAccount entity_account = 1;
	 */
	entityAccount?: EntityAccountJson;
};

/**
 * Describes the message billing.v1.CreateEntityAccountResponse.
 * Use `create(CreateEntityAccountResponseSchema)` to create a new message.
 */
export const CreateEntityAccountResponseSchema: GenMessage<CreateEntityAccountResponse, { jsonType: CreateEntityAccountResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 16);

/**
 * @generated from message billing.v1.GetSubscriptionRequest
 */
export type GetSubscriptionRequest = Message<"billing.v1.GetSubscriptionRequest"> & {
	/**
	 * The key of the subscription to get (DEPRECATED: use provider_subscription_number)
	 *
	 * @generated from field: string provider_subscription_key = 1 [deprecated = true];
	 * @deprecated
	 */
	providerSubscriptionKey: string;

	/**
	 * The number of the subscription
	 *
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber: string;
};

/**
 * @generated from message billing.v1.GetSubscriptionRequest
 */
export type GetSubscriptionRequestJson = {
	/**
	 * The key of the subscription to get (DEPRECATED: use provider_subscription_number)
	 *
	 * @generated from field: string provider_subscription_key = 1 [deprecated = true];
	 * @deprecated
	 */
	providerSubscriptionKey?: string;

	/**
	 * The number of the subscription
	 *
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber?: string;
};

/**
 * Describes the message billing.v1.GetSubscriptionRequest.
 * Use `create(GetSubscriptionRequestSchema)` to create a new message.
 */
export const GetSubscriptionRequestSchema: GenMessage<GetSubscriptionRequest, { jsonType: GetSubscriptionRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 17);

/**
 * @generated from message billing.v1.GetSubscriptionResponse
 */
export type GetSubscriptionResponse = Message<"billing.v1.GetSubscriptionResponse"> & {
	/**
	 * The subscription that was retrieved
	 *
	 * @generated from field: billing.v1.Subscription subscription = 1;
	 */
	subscription?: Subscription;
};

/**
 * @generated from message billing.v1.GetSubscriptionResponse
 */
export type GetSubscriptionResponseJson = {
	/**
	 * The subscription that was retrieved
	 *
	 * @generated from field: billing.v1.Subscription subscription = 1;
	 */
	subscription?: SubscriptionJson;
};

/**
 * Describes the message billing.v1.GetSubscriptionResponse.
 * Use `create(GetSubscriptionResponseSchema)` to create a new message.
 */
export const GetSubscriptionResponseSchema: GenMessage<GetSubscriptionResponse, { jsonType: GetSubscriptionResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 18);

/**
 * @generated from message billing.v1.ListUsageRecordsRequest
 */
export type ListUsageRecordsRequest = Message<"billing.v1.ListUsageRecordsRequest"> & {
	/**
	 * The provider account id
	 *
	 * @generated from field: string provider_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	providerAccountId: string;

	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId: string;

	/**
	 * The pagination arguments
	 *
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments;
};

/**
 * @generated from message billing.v1.ListUsageRecordsRequest
 */
export type ListUsageRecordsRequestJson = {
	/**
	 * The provider account id
	 *
	 * @generated from field: string provider_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	providerAccountId?: string;

	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId?: string;

	/**
	 * The pagination arguments
	 *
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message billing.v1.ListUsageRecordsRequest.
 * Use `create(ListUsageRecordsRequestSchema)` to create a new message.
 */
export const ListUsageRecordsRequestSchema: GenMessage<ListUsageRecordsRequest, { jsonType: ListUsageRecordsRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 19);

/**
 * @generated from message billing.v1.ListUsageRecordsResponse
 */
export type ListUsageRecordsResponse = Message<"billing.v1.ListUsageRecordsResponse"> & {
	/**
	 * The usage records that were retrieved
	 *
	 * @generated from field: repeated billing.v1.UsageRecord usage_records = 1;
	 */
	usageRecords: UsageRecord[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message billing.v1.ListUsageRecordsResponse
 */
export type ListUsageRecordsResponseJson = {
	/**
	 * The usage records that were retrieved
	 *
	 * @generated from field: repeated billing.v1.UsageRecord usage_records = 1;
	 */
	usageRecords?: UsageRecordJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message billing.v1.ListUsageRecordsResponse.
 * Use `create(ListUsageRecordsResponseSchema)` to create a new message.
 */
export const ListUsageRecordsResponseSchema: GenMessage<ListUsageRecordsResponse, { jsonType: ListUsageRecordsResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 20);

/**
 * @generated from message billing.v1.ListAdminUsageRecordsRequest
 */
export type ListAdminUsageRecordsRequest = Message<"billing.v1.ListAdminUsageRecordsRequest"> & {
	/**
	 * The provider account id
	 *
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId: string;

	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId: string;

	/**
	 * The pagination arguments
	 *
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArguments;
};

/**
 * @generated from message billing.v1.ListAdminUsageRecordsRequest
 */
export type ListAdminUsageRecordsRequestJson = {
	/**
	 * The provider account id
	 *
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId?: string;

	/**
	 * The entity account id
	 *
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId?: string;

	/**
	 * The pagination arguments
	 *
	 * @generated from field: optional common.v1.PaginationArguments paginate = 3;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message billing.v1.ListAdminUsageRecordsRequest.
 * Use `create(ListAdminUsageRecordsRequestSchema)` to create a new message.
 */
export const ListAdminUsageRecordsRequestSchema: GenMessage<ListAdminUsageRecordsRequest, { jsonType: ListAdminUsageRecordsRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 21);

/**
 * @generated from message billing.v1.ListAdminUsageRecordsResponse
 */
export type ListAdminUsageRecordsResponse = Message<"billing.v1.ListAdminUsageRecordsResponse"> & {
	/**
	 * The usage records that were retrieved
	 *
	 * @generated from field: repeated billing.v1.UsageRecord usage_records = 1;
	 */
	usageRecords: UsageRecord[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message billing.v1.ListAdminUsageRecordsResponse
 */
export type ListAdminUsageRecordsResponseJson = {
	/**
	 * The usage records that were retrieved
	 *
	 * @generated from field: repeated billing.v1.UsageRecord usage_records = 1;
	 */
	usageRecords?: UsageRecordJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message billing.v1.ListAdminUsageRecordsResponse.
 * Use `create(ListAdminUsageRecordsResponseSchema)` to create a new message.
 */
export const ListAdminUsageRecordsResponseSchema: GenMessage<ListAdminUsageRecordsResponse, { jsonType: ListAdminUsageRecordsResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 22);

/**
 * SubscriptionHookRequest is the payload of the subscription webhook event
 *
 * @generated from message billing.v1.SubscriptionHookRequest
 */
export type SubscriptionHookRequest = Message<"billing.v1.SubscriptionHookRequest"> & {
	/**
	 * @generated from field: string account_id = 1 [json_name = "AccountId"];
	 */
	accountId: string;

	/**
	 * @generated from field: string account_number = 2 [json_name = "AccountAccountNumber"];
	 */
	accountNumber: string;

	/**
	 * @generated from field: string subscription_id = 3 [json_name = "SubscriptionId"];
	 */
	subscriptionId: string;

	/**
	 * @generated from field: string subscription_number = 4 [json_name = "SubscriptionName"];
	 */
	subscriptionNumber: string;

	/**
	 * @generated from field: string subscription_status = 5 [json_name = "SubscriptionStatus"];
	 */
	subscriptionStatus: string;

	/**
	 * @generated from field: string subscription_auto_renew = 6 [json_name = "SubscriptionAutoRenew"];
	 */
	subscriptionAutoRenew: string;

	/**
	 * @generated from field: string subscription_is_latest_version = 7 [json_name = "SubscriptionIsLatestVersion"];
	 */
	subscriptionIsLatestVersion: string;

	/**
	 * @generated from field: string subscription_term_end_date = 8 [json_name = "SubscriptionTermEndDate"];
	 */
	subscriptionTermEndDate: string;

	/**
	 * @generated from field: string subscription_term_start_date = 9 [json_name = "SubscriptionTermStartDate"];
	 */
	subscriptionTermStartDate: string;

	/**
	 * @generated from field: string subscription_term_type = 10 [json_name = "SubscriptionTermType"];
	 */
	subscriptionTermType: string;

	/**
	 * @generated from field: string subscription_end_date = 11 [json_name = "SubscriptionSubscriptionEndDate"];
	 */
	subscriptionEndDate: string;

	/**
	 * @generated from field: string event_category = 12 [json_name = "EventCategory"];
	 */
	eventCategory: string;

	/**
	 * @generated from field: string event_date = 13 [json_name = "EventDate"];
	 */
	eventDate: string;

	/**
	 * @generated from field: string event_timestamp = 14 [json_name = "EventTimestamp"];
	 */
	eventTimestamp: string;
};

/**
 * SubscriptionHookRequest is the payload of the subscription webhook event
 *
 * @generated from message billing.v1.SubscriptionHookRequest
 */
export type SubscriptionHookRequestJson = {
	/**
	 * @generated from field: string account_id = 1 [json_name = "AccountId"];
	 */
	AccountId?: string;

	/**
	 * @generated from field: string account_number = 2 [json_name = "AccountAccountNumber"];
	 */
	AccountAccountNumber?: string;

	/**
	 * @generated from field: string subscription_id = 3 [json_name = "SubscriptionId"];
	 */
	SubscriptionId?: string;

	/**
	 * @generated from field: string subscription_number = 4 [json_name = "SubscriptionName"];
	 */
	SubscriptionName?: string;

	/**
	 * @generated from field: string subscription_status = 5 [json_name = "SubscriptionStatus"];
	 */
	SubscriptionStatus?: string;

	/**
	 * @generated from field: string subscription_auto_renew = 6 [json_name = "SubscriptionAutoRenew"];
	 */
	SubscriptionAutoRenew?: string;

	/**
	 * @generated from field: string subscription_is_latest_version = 7 [json_name = "SubscriptionIsLatestVersion"];
	 */
	SubscriptionIsLatestVersion?: string;

	/**
	 * @generated from field: string subscription_term_end_date = 8 [json_name = "SubscriptionTermEndDate"];
	 */
	SubscriptionTermEndDate?: string;

	/**
	 * @generated from field: string subscription_term_start_date = 9 [json_name = "SubscriptionTermStartDate"];
	 */
	SubscriptionTermStartDate?: string;

	/**
	 * @generated from field: string subscription_term_type = 10 [json_name = "SubscriptionTermType"];
	 */
	SubscriptionTermType?: string;

	/**
	 * @generated from field: string subscription_end_date = 11 [json_name = "SubscriptionSubscriptionEndDate"];
	 */
	SubscriptionSubscriptionEndDate?: string;

	/**
	 * @generated from field: string event_category = 12 [json_name = "EventCategory"];
	 */
	EventCategory?: string;

	/**
	 * @generated from field: string event_date = 13 [json_name = "EventDate"];
	 */
	EventDate?: string;

	/**
	 * @generated from field: string event_timestamp = 14 [json_name = "EventTimestamp"];
	 */
	EventTimestamp?: string;
};

/**
 * Describes the message billing.v1.SubscriptionHookRequest.
 * Use `create(SubscriptionHookRequestSchema)` to create a new message.
 */
export const SubscriptionHookRequestSchema: GenMessage<SubscriptionHookRequest, { jsonType: SubscriptionHookRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 23);

/**
 * SubscriptionHookResponse is the response to the subscription webhook event
 *
 * @generated from message billing.v1.SubscriptionHookResponse
 */
export type SubscriptionHookResponse = Message<"billing.v1.SubscriptionHookResponse"> & {
	/**
	 * @generated from field: string message = 1;
	 */
	message: string;
};

/**
 * SubscriptionHookResponse is the response to the subscription webhook event
 *
 * @generated from message billing.v1.SubscriptionHookResponse
 */
export type SubscriptionHookResponseJson = {
	/**
	 * @generated from field: string message = 1;
	 */
	message?: string;
};

/**
 * Describes the message billing.v1.SubscriptionHookResponse.
 * Use `create(SubscriptionHookResponseSchema)` to create a new message.
 */
export const SubscriptionHookResponseSchema: GenMessage<SubscriptionHookResponse, { jsonType: SubscriptionHookResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 24);

/**
 * @generated from message billing.v1.GetSubscriptionStateRequest
 */
export type GetSubscriptionStateRequest = Message<"billing.v1.GetSubscriptionStateRequest"> & {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;
};

/**
 * @generated from message billing.v1.GetSubscriptionStateRequest
 */
export type GetSubscriptionStateRequestJson = {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;
};

/**
 * Describes the message billing.v1.GetSubscriptionStateRequest.
 * Use `create(GetSubscriptionStateRequestSchema)` to create a new message.
 */
export const GetSubscriptionStateRequestSchema: GenMessage<GetSubscriptionStateRequest, { jsonType: GetSubscriptionStateRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 25);

/**
 * @generated from message billing.v1.GetSubscriptionStateResponse
 */
export type GetSubscriptionStateResponse = Message<"billing.v1.GetSubscriptionStateResponse"> & {
	/**
	 * @generated from field: billing.v1.SubscriptionState state = 1;
	 */
	state: SubscriptionState;

	/**
	 * @generated from field: optional google.protobuf.Timestamp end_date = 2;
	 */
	endDate?: Timestamp;
};

/**
 * @generated from message billing.v1.GetSubscriptionStateResponse
 */
export type GetSubscriptionStateResponseJson = {
	/**
	 * @generated from field: billing.v1.SubscriptionState state = 1;
	 */
	state?: SubscriptionStateJson;

	/**
	 * @generated from field: optional google.protobuf.Timestamp end_date = 2;
	 */
	endDate?: TimestampJson;
};

/**
 * Describes the message billing.v1.GetSubscriptionStateResponse.
 * Use `create(GetSubscriptionStateResponseSchema)` to create a new message.
 */
export const GetSubscriptionStateResponseSchema: GenMessage<GetSubscriptionStateResponse, { jsonType: GetSubscriptionStateResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 26);

/**
 * @generated from message billing.v1.CreateTrialSubscriptionRequest
 */
export type CreateTrialSubscriptionRequest = Message<"billing.v1.CreateTrialSubscriptionRequest"> & {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;

	/**
	 * @generated from field: billing.v1.EntityAccountType entity_account_type = 2;
	 */
	entityAccountType: EntityAccountType;

	/**
	 * @generated from field: int32 trial_period_days = 4;
	 */
	trialPeriodDays: number;
};

/**
 * @generated from message billing.v1.CreateTrialSubscriptionRequest
 */
export type CreateTrialSubscriptionRequestJson = {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: billing.v1.EntityAccountType entity_account_type = 2;
	 */
	entityAccountType?: EntityAccountTypeJson;

	/**
	 * @generated from field: int32 trial_period_days = 4;
	 */
	trialPeriodDays?: number;
};

/**
 * Describes the message billing.v1.CreateTrialSubscriptionRequest.
 * Use `create(CreateTrialSubscriptionRequestSchema)` to create a new message.
 */
export const CreateTrialSubscriptionRequestSchema: GenMessage<CreateTrialSubscriptionRequest, { jsonType: CreateTrialSubscriptionRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 27);

/**
 * @generated from message billing.v1.CreateTrialSubscriptionResponse
 */
export type CreateTrialSubscriptionResponse = Message<"billing.v1.CreateTrialSubscriptionResponse"> & {
	/**
	 * @generated from field: string provider_subscription_id = 1;
	 */
	providerSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber: string;
};

/**
 * @generated from message billing.v1.CreateTrialSubscriptionResponse
 */
export type CreateTrialSubscriptionResponseJson = {
	/**
	 * @generated from field: string provider_subscription_id = 1;
	 */
	providerSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber?: string;
};

/**
 * Describes the message billing.v1.CreateTrialSubscriptionResponse.
 * Use `create(CreateTrialSubscriptionResponseSchema)` to create a new message.
 */
export const CreateTrialSubscriptionResponseSchema: GenMessage<CreateTrialSubscriptionResponse, { jsonType: CreateTrialSubscriptionResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 28);

/**
 * @generated from message billing.v1.CreateOrderResponse
 */
export type CreateOrderResponse = Message<"billing.v1.CreateOrderResponse"> & {
	/**
	 * @generated from field: string order_id = 1;
	 */
	orderId: string;

	/**
	 * @generated from field: string order_number = 2;
	 */
	orderNumber: string;

	/**
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId: string;

	/**
	 * @generated from field: string provider_account_number = 4;
	 */
	providerAccountNumber: string;

	/**
	 * @generated from field: string provider_subscription_id = 5;
	 */
	providerSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_number = 6;
	 */
	providerSubscriptionNumber: string;

	/**
	 * @generated from field: billing.v1.SubscriptionStatus subscription_status = 7;
	 */
	subscriptionStatus: SubscriptionStatus;
};

/**
 * @generated from message billing.v1.CreateOrderResponse
 */
export type CreateOrderResponseJson = {
	/**
	 * @generated from field: string order_id = 1;
	 */
	orderId?: string;

	/**
	 * @generated from field: string order_number = 2;
	 */
	orderNumber?: string;

	/**
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId?: string;

	/**
	 * @generated from field: string provider_account_number = 4;
	 */
	providerAccountNumber?: string;

	/**
	 * @generated from field: string provider_subscription_id = 5;
	 */
	providerSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 6;
	 */
	providerSubscriptionNumber?: string;

	/**
	 * @generated from field: billing.v1.SubscriptionStatus subscription_status = 7;
	 */
	subscriptionStatus?: SubscriptionStatusJson;
};

/**
 * Describes the message billing.v1.CreateOrderResponse.
 * Use `create(CreateOrderResponseSchema)` to create a new message.
 */
export const CreateOrderResponseSchema: GenMessage<CreateOrderResponse, { jsonType: CreateOrderResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 29);

/**
 * @generated from message billing.v1.ExtendTrialRequest
 */
export type ExtendTrialRequest = Message<"billing.v1.ExtendTrialRequest"> & {
	/**
	 * TODO: Remove this field because we can permission check on the sub
	 *
	 * @generated from field: string entity_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	entityAccountId: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber: string;

	/**
	 * @generated from field: google.protobuf.Timestamp trial_end_date = 3;
	 */
	trialEndDate?: Timestamp;
};

/**
 * @generated from message billing.v1.ExtendTrialRequest
 */
export type ExtendTrialRequestJson = {
	/**
	 * TODO: Remove this field because we can permission check on the sub
	 *
	 * @generated from field: string entity_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp trial_end_date = 3;
	 */
	trialEndDate?: TimestampJson;
};

/**
 * Describes the message billing.v1.ExtendTrialRequest.
 * Use `create(ExtendTrialRequestSchema)` to create a new message.
 */
export const ExtendTrialRequestSchema: GenMessage<ExtendTrialRequest, { jsonType: ExtendTrialRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 30);

/**
 * @generated from message billing.v1.ExtendTrialResponse
 */
export type ExtendTrialResponse = Message<"billing.v1.ExtendTrialResponse"> & {
	/**
	 * @generated from field: string provider_subscription_id = 1;
	 */
	providerSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber: string;
};

/**
 * @generated from message billing.v1.ExtendTrialResponse
 */
export type ExtendTrialResponseJson = {
	/**
	 * @generated from field: string provider_subscription_id = 1;
	 */
	providerSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber?: string;
};

/**
 * Describes the message billing.v1.ExtendTrialResponse.
 * Use `create(ExtendTrialResponseSchema)` to create a new message.
 */
export const ExtendTrialResponseSchema: GenMessage<ExtendTrialResponse, { jsonType: ExtendTrialResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 31);

/**
 * @generated from message billing.v1.CreatePaymentSessionRequest
 */
export type CreatePaymentSessionRequest = Message<"billing.v1.CreatePaymentSessionRequest"> & {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;
};

/**
 * @generated from message billing.v1.CreatePaymentSessionRequest
 */
export type CreatePaymentSessionRequestJson = {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;
};

/**
 * Describes the message billing.v1.CreatePaymentSessionRequest.
 * Use `create(CreatePaymentSessionRequestSchema)` to create a new message.
 */
export const CreatePaymentSessionRequestSchema: GenMessage<CreatePaymentSessionRequest, { jsonType: CreatePaymentSessionRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 32);

/**
 * @generated from message billing.v1.CreatePaymentSessionResponse
 */
export type CreatePaymentSessionResponse = Message<"billing.v1.CreatePaymentSessionResponse"> & {
	/**
	 * @generated from field: string payment_session_token = 1;
	 */
	paymentSessionToken: string;
};

/**
 * @generated from message billing.v1.CreatePaymentSessionResponse
 */
export type CreatePaymentSessionResponseJson = {
	/**
	 * @generated from field: string payment_session_token = 1;
	 */
	paymentSessionToken?: string;
};

/**
 * Describes the message billing.v1.CreatePaymentSessionResponse.
 * Use `create(CreatePaymentSessionResponseSchema)` to create a new message.
 */
export const CreatePaymentSessionResponseSchema: GenMessage<CreatePaymentSessionResponse, { jsonType: CreatePaymentSessionResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 33);

/**
 * @generated from message billing.v1.ListPaymentMethodsRequest
 */
export type ListPaymentMethodsRequest = Message<"billing.v1.ListPaymentMethodsRequest"> & {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments;
};

/**
 * @generated from message billing.v1.ListPaymentMethodsRequest
 */
export type ListPaymentMethodsRequestJson = {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message billing.v1.ListPaymentMethodsRequest.
 * Use `create(ListPaymentMethodsRequestSchema)` to create a new message.
 */
export const ListPaymentMethodsRequestSchema: GenMessage<ListPaymentMethodsRequest, { jsonType: ListPaymentMethodsRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 34);

/**
 * @generated from message billing.v1.ListPaymentMethodsResponse
 */
export type ListPaymentMethodsResponse = Message<"billing.v1.ListPaymentMethodsResponse"> & {
	/**
	 * @generated from field: repeated billing.v1.PaymentMethod payment_methods = 1;
	 */
	paymentMethods: PaymentMethod[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message billing.v1.ListPaymentMethodsResponse
 */
export type ListPaymentMethodsResponseJson = {
	/**
	 * @generated from field: repeated billing.v1.PaymentMethod payment_methods = 1;
	 */
	paymentMethods?: PaymentMethodJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message billing.v1.ListPaymentMethodsResponse.
 * Use `create(ListPaymentMethodsResponseSchema)` to create a new message.
 */
export const ListPaymentMethodsResponseSchema: GenMessage<ListPaymentMethodsResponse, { jsonType: ListPaymentMethodsResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 35);

/**
 * @generated from message billing.v1.UpgradeSubscriptionRequest
 */
export type UpgradeSubscriptionRequest = Message<"billing.v1.UpgradeSubscriptionRequest"> & {
	/**
	 * TODO: Remove this field because we can permission check on the sub
	 *
	 * @generated from field: string entity_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	entityAccountId: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 2;
	 */
	providerProductRatePlanId: string;

	/**
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber: string;
};

/**
 * @generated from message billing.v1.UpgradeSubscriptionRequest
 */
export type UpgradeSubscriptionRequestJson = {
	/**
	 * TODO: Remove this field because we can permission check on the sub
	 *
	 * @generated from field: string entity_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 2;
	 */
	providerProductRatePlanId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber?: string;
};

/**
 * Describes the message billing.v1.UpgradeSubscriptionRequest.
 * Use `create(UpgradeSubscriptionRequestSchema)` to create a new message.
 */
export const UpgradeSubscriptionRequestSchema: GenMessage<UpgradeSubscriptionRequest, { jsonType: UpgradeSubscriptionRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 36);

/**
 * @generated from message billing.v1.UpgradeSubscriptionResponse
 */
export type UpgradeSubscriptionResponse = Message<"billing.v1.UpgradeSubscriptionResponse"> & {
	/**
	 * @generated from field: string provider_subscription_id = 1;
	 */
	providerSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber: string;
};

/**
 * @generated from message billing.v1.UpgradeSubscriptionResponse
 */
export type UpgradeSubscriptionResponseJson = {
	/**
	 * @generated from field: string provider_subscription_id = 1;
	 */
	providerSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 2;
	 */
	providerSubscriptionNumber?: string;
};

/**
 * Describes the message billing.v1.UpgradeSubscriptionResponse.
 * Use `create(UpgradeSubscriptionResponseSchema)` to create a new message.
 */
export const UpgradeSubscriptionResponseSchema: GenMessage<UpgradeSubscriptionResponse, { jsonType: UpgradeSubscriptionResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 37);

/**
 * @generated from message billing.v1.PreviewUpgradeSubscriptionRequest
 */
export type PreviewUpgradeSubscriptionRequest = Message<"billing.v1.PreviewUpgradeSubscriptionRequest"> & {
	/**
	 * TODO: Remove this field because we can permission check on the sub
	 *
	 * @generated from field: string entity_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	entityAccountId: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 2;
	 */
	providerProductRatePlanId: string;

	/**
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber: string;
};

/**
 * @generated from message billing.v1.PreviewUpgradeSubscriptionRequest
 */
export type PreviewUpgradeSubscriptionRequestJson = {
	/**
	 * TODO: Remove this field because we can permission check on the sub
	 *
	 * @generated from field: string entity_account_id = 1 [deprecated = true];
	 * @deprecated
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 2;
	 */
	providerProductRatePlanId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber?: string;
};

/**
 * Describes the message billing.v1.PreviewUpgradeSubscriptionRequest.
 * Use `create(PreviewUpgradeSubscriptionRequestSchema)` to create a new message.
 */
export const PreviewUpgradeSubscriptionRequestSchema: GenMessage<PreviewUpgradeSubscriptionRequest, { jsonType: PreviewUpgradeSubscriptionRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 38);

/**
 * @generated from message billing.v1.PreviewUpgradeSubscriptionResponse
 */
export type PreviewUpgradeSubscriptionResponse = Message<"billing.v1.PreviewUpgradeSubscriptionResponse"> & {
	/**
	 * @generated from field: double amount = 1;
	 */
	amount: number;

	/**
	 * @generated from field: double amount_without_tax = 2;
	 */
	amountWithoutTax: number;

	/**
	 * @generated from field: double tax_amount = 3;
	 */
	taxAmount: number;
};

/**
 * @generated from message billing.v1.PreviewUpgradeSubscriptionResponse
 */
export type PreviewUpgradeSubscriptionResponseJson = {
	/**
	 * @generated from field: double amount = 1;
	 */
	amount?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double amount_without_tax = 2;
	 */
	amountWithoutTax?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double tax_amount = 3;
	 */
	taxAmount?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message billing.v1.PreviewUpgradeSubscriptionResponse.
 * Use `create(PreviewUpgradeSubscriptionResponseSchema)` to create a new message.
 */
export const PreviewUpgradeSubscriptionResponseSchema: GenMessage<PreviewUpgradeSubscriptionResponse, { jsonType: PreviewUpgradeSubscriptionResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 39);

/**
 * @generated from message billing.v1.GeneratePaymentSignatureRequest
 */
export type GeneratePaymentSignatureRequest = Message<"billing.v1.GeneratePaymentSignatureRequest"> & {
	/**
	 * @generated from field: string payment_page_id = 1;
	 */
	paymentPageId: string;
};

/**
 * @generated from message billing.v1.GeneratePaymentSignatureRequest
 */
export type GeneratePaymentSignatureRequestJson = {
	/**
	 * @generated from field: string payment_page_id = 1;
	 */
	paymentPageId?: string;
};

/**
 * Describes the message billing.v1.GeneratePaymentSignatureRequest.
 * Use `create(GeneratePaymentSignatureRequestSchema)` to create a new message.
 */
export const GeneratePaymentSignatureRequestSchema: GenMessage<GeneratePaymentSignatureRequest, { jsonType: GeneratePaymentSignatureRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 40);

/**
 * @generated from message billing.v1.GeneratePaymentSignatureResponse
 */
export type GeneratePaymentSignatureResponse = Message<"billing.v1.GeneratePaymentSignatureResponse"> & {
	/**
	 * @generated from field: string signature = 1;
	 */
	signature: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * @generated from field: string token = 3;
	 */
	token: string;

	/**
	 * @generated from field: string tenant_id = 4;
	 */
	tenantId: string;

	/**
	 * @generated from field: string payment_page_url = 5;
	 */
	paymentPageUrl: string;
};

/**
 * @generated from message billing.v1.GeneratePaymentSignatureResponse
 */
export type GeneratePaymentSignatureResponseJson = {
	/**
	 * @generated from field: string signature = 1;
	 */
	signature?: string;

	/**
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * @generated from field: string token = 3;
	 */
	token?: string;

	/**
	 * @generated from field: string tenant_id = 4;
	 */
	tenantId?: string;

	/**
	 * @generated from field: string payment_page_url = 5;
	 */
	paymentPageUrl?: string;
};

/**
 * Describes the message billing.v1.GeneratePaymentSignatureResponse.
 * Use `create(GeneratePaymentSignatureResponseSchema)` to create a new message.
 */
export const GeneratePaymentSignatureResponseSchema: GenMessage<GeneratePaymentSignatureResponse, { jsonType: GeneratePaymentSignatureResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 41);

/**
 * @generated from message billing.v1.GetAdminAccountRequest
 */
export type GetAdminAccountRequest = Message<"billing.v1.GetAdminAccountRequest"> & {
	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId: string;
};

/**
 * @generated from message billing.v1.GetAdminAccountRequest
 */
export type GetAdminAccountRequestJson = {
	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId?: string;
};

/**
 * Describes the message billing.v1.GetAdminAccountRequest.
 * Use `create(GetAdminAccountRequestSchema)` to create a new message.
 */
export const GetAdminAccountRequestSchema: GenMessage<GetAdminAccountRequest, { jsonType: GetAdminAccountRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 42);

/**
 * @generated from message billing.v1.GetAdminAccountResponse
 */
export type GetAdminAccountResponse = Message<"billing.v1.GetAdminAccountResponse"> & {
	/**
	 * @generated from field: billing.v1.Account account = 1;
	 */
	account?: Account;
};

/**
 * @generated from message billing.v1.GetAdminAccountResponse
 */
export type GetAdminAccountResponseJson = {
	/**
	 * @generated from field: billing.v1.Account account = 1;
	 */
	account?: AccountJson;
};

/**
 * Describes the message billing.v1.GetAdminAccountResponse.
 * Use `create(GetAdminAccountResponseSchema)` to create a new message.
 */
export const GetAdminAccountResponseSchema: GenMessage<GetAdminAccountResponse, { jsonType: GetAdminAccountResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 43);

/**
 * @generated from message billing.v1.Invoice
 */
export type Invoice = Message<"billing.v1.Invoice"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string invoice_number = 2;
	 */
	invoiceNumber: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 3;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 4;
	 */
	updatedAt?: Timestamp;

	/**
	 * @generated from field: string provider_account_id = 5;
	 */
	providerAccountId: string;

	/**
	 * @generated from field: double amount = 6;
	 */
	amount: number;

	/**
	 * @generated from field: double amount_without_tax = 7;
	 */
	amountWithoutTax: number;

	/**
	 * @generated from field: double balance = 8;
	 */
	balance: number;

	/**
	 * @generated from field: string comments = 9;
	 */
	comments: string;

	/**
	 * @generated from field: google.protobuf.Timestamp due_date = 10;
	 */
	dueDate?: Timestamp;

	/**
	 * @generated from field: double payment_amount = 11;
	 */
	paymentAmount: number;

	/**
	 * @generated from field: double tax_amount = 12;
	 */
	taxAmount: number;

	/**
	 * @generated from field: billing.v1.InvoiceStatus status = 13;
	 */
	status: InvoiceStatus;
};

/**
 * @generated from message billing.v1.Invoice
 */
export type InvoiceJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string invoice_number = 2;
	 */
	invoiceNumber?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 3;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 4;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: string provider_account_id = 5;
	 */
	providerAccountId?: string;

	/**
	 * @generated from field: double amount = 6;
	 */
	amount?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double amount_without_tax = 7;
	 */
	amountWithoutTax?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double balance = 8;
	 */
	balance?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: string comments = 9;
	 */
	comments?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp due_date = 10;
	 */
	dueDate?: TimestampJson;

	/**
	 * @generated from field: double payment_amount = 11;
	 */
	paymentAmount?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double tax_amount = 12;
	 */
	taxAmount?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: billing.v1.InvoiceStatus status = 13;
	 */
	status?: InvoiceStatusJson;
};

/**
 * Describes the message billing.v1.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
export const InvoiceSchema: GenMessage<Invoice, { jsonType: InvoiceJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 44);

/**
 * @generated from message billing.v1.ListInvoicesRequest
 */
export type ListInvoicesRequest = Message<"billing.v1.ListInvoicesRequest"> & {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArguments;
};

/**
 * @generated from message billing.v1.ListInvoicesRequest
 */
export type ListInvoicesRequestJson = {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments paginate = 2;
	 */
	paginate?: PaginationArgumentsJson;
};

/**
 * Describes the message billing.v1.ListInvoicesRequest.
 * Use `create(ListInvoicesRequestSchema)` to create a new message.
 */
export const ListInvoicesRequestSchema: GenMessage<ListInvoicesRequest, { jsonType: ListInvoicesRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 45);

/**
 * @generated from message billing.v1.ListInvoicesResponse
 */
export type ListInvoicesResponse = Message<"billing.v1.ListInvoicesResponse"> & {
	/**
	 * @generated from field: repeated billing.v1.Invoice invoices = 1;
	 */
	invoices: Invoice[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message billing.v1.ListInvoicesResponse
 */
export type ListInvoicesResponseJson = {
	/**
	 * @generated from field: repeated billing.v1.Invoice invoices = 1;
	 */
	invoices?: InvoiceJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message billing.v1.ListInvoicesResponse.
 * Use `create(ListInvoicesResponseSchema)` to create a new message.
 */
export const ListInvoicesResponseSchema: GenMessage<ListInvoicesResponse, { jsonType: ListInvoicesResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 46);

/**
 * @generated from message billing.v1.DownloadInvoicePDFRequest
 */
export type DownloadInvoicePDFRequest = Message<"billing.v1.DownloadInvoicePDFRequest"> & {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;

	/**
	 * @generated from field: string invoice_number = 2;
	 */
	invoiceNumber: string;
};

/**
 * @generated from message billing.v1.DownloadInvoicePDFRequest
 */
export type DownloadInvoicePDFRequestJson = {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: string invoice_number = 2;
	 */
	invoiceNumber?: string;
};

/**
 * Describes the message billing.v1.DownloadInvoicePDFRequest.
 * Use `create(DownloadInvoicePDFRequestSchema)` to create a new message.
 */
export const DownloadInvoicePDFRequestSchema: GenMessage<DownloadInvoicePDFRequest, { jsonType: DownloadInvoicePDFRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 47);

/**
 * @generated from message billing.v1.DownloadInvoicePDFResponse
 */
export type DownloadInvoicePDFResponse = Message<"billing.v1.DownloadInvoicePDFResponse"> & {
	/**
	 * presigned url to download the file
	 *
	 * @generated from field: string invoice_download_url = 1;
	 */
	invoiceDownloadUrl: string;
};

/**
 * @generated from message billing.v1.DownloadInvoicePDFResponse
 */
export type DownloadInvoicePDFResponseJson = {
	/**
	 * presigned url to download the file
	 *
	 * @generated from field: string invoice_download_url = 1;
	 */
	invoiceDownloadUrl?: string;
};

/**
 * Describes the message billing.v1.DownloadInvoicePDFResponse.
 * Use `create(DownloadInvoicePDFResponseSchema)` to create a new message.
 */
export const DownloadInvoicePDFResponseSchema: GenMessage<DownloadInvoicePDFResponse, { jsonType: DownloadInvoicePDFResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 48);

/**
 * @generated from message billing.v1.GetUsageSummaryRequest
 */
export type GetUsageSummaryRequest = Message<"billing.v1.GetUsageSummaryRequest"> & {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId: string;

	/**
	 * @generated from field: billing.v1.FeatureType feature_type = 2;
	 */
	featureType: FeatureType;

	/**
	 * @generated from field: billing.v1.WindowSize window_size = 3;
	 */
	windowSize: WindowSize;
};

/**
 * @generated from message billing.v1.GetUsageSummaryRequest
 */
export type GetUsageSummaryRequestJson = {
	/**
	 * @generated from field: string entity_account_id = 1;
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: billing.v1.FeatureType feature_type = 2;
	 */
	featureType?: FeatureTypeJson;

	/**
	 * @generated from field: billing.v1.WindowSize window_size = 3;
	 */
	windowSize?: WindowSizeJson;
};

/**
 * Describes the message billing.v1.GetUsageSummaryRequest.
 * Use `create(GetUsageSummaryRequestSchema)` to create a new message.
 */
export const GetUsageSummaryRequestSchema: GenMessage<GetUsageSummaryRequest, { jsonType: GetUsageSummaryRequestJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 49);

/**
 * @generated from message billing.v1.GetUsageSummaryResponse
 */
export type GetUsageSummaryResponse = Message<"billing.v1.GetUsageSummaryResponse"> & {
	/**
	 * @generated from field: billing.v1.UsageSummary usage_summary = 1;
	 */
	usageSummary?: UsageSummary;
};

/**
 * @generated from message billing.v1.GetUsageSummaryResponse
 */
export type GetUsageSummaryResponseJson = {
	/**
	 * @generated from field: billing.v1.UsageSummary usage_summary = 1;
	 */
	usageSummary?: UsageSummaryJson;
};

/**
 * Describes the message billing.v1.GetUsageSummaryResponse.
 * Use `create(GetUsageSummaryResponseSchema)` to create a new message.
 */
export const GetUsageSummaryResponseSchema: GenMessage<GetUsageSummaryResponse, { jsonType: GetUsageSummaryResponseJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 50);

/**
 * @generated from message billing.v1.UsageSummary
 */
export type UsageSummary = Message<"billing.v1.UsageSummary"> & {
	/**
	 * @generated from field: billing.v1.FeatureType feature_type = 1;
	 */
	featureType: FeatureType;

	/**
	 * @generated from field: google.protobuf.Timestamp period_start = 3;
	 */
	periodStart?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp period_end = 4;
	 */
	periodEnd?: Timestamp;

	/**
	 * @generated from field: repeated billing.v1.UsageTotal totals = 5;
	 */
	totals: UsageTotal[];

	/**
	 * @generated from field: billing.v1.WindowSize window_size = 6;
	 */
	windowSize: WindowSize;

	/**
	 * @generated from field: double total_value = 7;
	 */
	totalValue: number;

	/**
	 * @generated from field: int32 current_usage_total_index = 8;
	 */
	currentUsageTotalIndex: number;
};

/**
 * @generated from message billing.v1.UsageSummary
 */
export type UsageSummaryJson = {
	/**
	 * @generated from field: billing.v1.FeatureType feature_type = 1;
	 */
	featureType?: FeatureTypeJson;

	/**
	 * @generated from field: google.protobuf.Timestamp period_start = 3;
	 */
	periodStart?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp period_end = 4;
	 */
	periodEnd?: TimestampJson;

	/**
	 * @generated from field: repeated billing.v1.UsageTotal totals = 5;
	 */
	totals?: UsageTotalJson[];

	/**
	 * @generated from field: billing.v1.WindowSize window_size = 6;
	 */
	windowSize?: WindowSizeJson;

	/**
	 * @generated from field: double total_value = 7;
	 */
	totalValue?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: int32 current_usage_total_index = 8;
	 */
	currentUsageTotalIndex?: number;
};

/**
 * Describes the message billing.v1.UsageSummary.
 * Use `create(UsageSummarySchema)` to create a new message.
 */
export const UsageSummarySchema: GenMessage<UsageSummary, { jsonType: UsageSummaryJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 51);

/**
 * @generated from message billing.v1.UsageTotal
 */
export type UsageTotal = Message<"billing.v1.UsageTotal"> & {
	/**
	 * The date that the event was recorded.
	 *
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: Date;

	/**
	 * If an HOUR period is specified, truncates the timestamp
	 * to the start of the hour.
	 *
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number;

	/**
	 * Total number of events.
	 *
	 * @generated from field: int64 value = 3;
	 */
	value: bigint;
};

/**
 * @generated from message billing.v1.UsageTotal
 */
export type UsageTotalJson = {
	/**
	 * The date that the event was recorded.
	 *
	 * @generated from field: google.type.Date date = 1;
	 */
	date?: DateJson;

	/**
	 * If an HOUR period is specified, truncates the timestamp
	 * to the start of the hour.
	 *
	 * @generated from field: optional int32 hour = 2;
	 */
	hour?: number;

	/**
	 * Total number of events.
	 *
	 * @generated from field: int64 value = 3;
	 */
	value?: string;
};

/**
 * Describes the message billing.v1.UsageTotal.
 * Use `create(UsageTotalSchema)` to create a new message.
 */
export const UsageTotalSchema: GenMessage<UsageTotal, { jsonType: UsageTotalJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_service, 52);

/**
 * @generated from enum billing.v1.FilterOperator
 */
export enum FilterOperator {
	/**
	 * @generated from enum value: FILTER_OPERATOR_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: FILTER_OPERATOR_EQUALS = 1;
	 */
	EQUALS = 1,

	/**
	 * @generated from enum value: FILTER_OPERATOR_NOT_EQUALS = 2;
	 */
	NOT_EQUALS = 2,

	/**
	 * @generated from enum value: FILTER_OPERATOR_LESS_THAN = 3;
	 */
	LESS_THAN = 3,

	/**
	 * @generated from enum value: FILTER_OPERATOR_GREATER_THAN = 4;
	 */
	GREATER_THAN = 4,

	/**
	 * @generated from enum value: FILTER_OPERATOR_STARTS_WITH = 5;
	 */
	STARTS_WITH = 5,

	/**
	 * @generated from enum value: FILTER_OPERATOR_IN = 6;
	 */
	IN = 6,

	/**
	 * @generated from enum value: FILTER_OPERATOR_LESS_THAN_OR_EQUALS = 7;
	 */
	LESS_THAN_OR_EQUALS = 7,

	/**
	 * @generated from enum value: FILTER_OPERATOR_GREATER_THAN_OR_EQUALS = 8;
	 */
	GREATER_THAN_OR_EQUALS = 8,
}

/**
 * @generated from enum billing.v1.FilterOperator
 */
export type FilterOperatorJson = "FILTER_OPERATOR_UNSPECIFIED" | "FILTER_OPERATOR_EQUALS" | "FILTER_OPERATOR_NOT_EQUALS" | "FILTER_OPERATOR_LESS_THAN" | "FILTER_OPERATOR_GREATER_THAN" | "FILTER_OPERATOR_STARTS_WITH" | "FILTER_OPERATOR_IN" | "FILTER_OPERATOR_LESS_THAN_OR_EQUALS" | "FILTER_OPERATOR_GREATER_THAN_OR_EQUALS";

/**
 * Describes the enum billing.v1.FilterOperator.
 */
export const FilterOperatorSchema: GenEnum<FilterOperator, FilterOperatorJson> = /*@__PURE__*/ enumDesc(file_billing_v1_service, 0);

/**
 * @generated from enum billing.v1.AccountSearchField
 */
export enum AccountSearchField {
	/**
	 * @generated from enum value: ACCOUNT_SEARCH_FIELD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ACCOUNT_SEARCH_FIELD_NAME = 1;
	 */
	NAME = 1,

	/**
	 * @generated from enum value: ACCOUNT_SEARCH_FIELD_PROVIDER_ACCOUNT_ID = 2;
	 */
	PROVIDER_ACCOUNT_ID = 2,

	/**
	 * @generated from enum value: ACCOUNT_SEARCH_FIELD_PROVIDER_ACCOUNT_NUMBER = 3;
	 */
	PROVIDER_ACCOUNT_NUMBER = 3,
}

/**
 * @generated from enum billing.v1.AccountSearchField
 */
export type AccountSearchFieldJson = "ACCOUNT_SEARCH_FIELD_UNSPECIFIED" | "ACCOUNT_SEARCH_FIELD_NAME" | "ACCOUNT_SEARCH_FIELD_PROVIDER_ACCOUNT_ID" | "ACCOUNT_SEARCH_FIELD_PROVIDER_ACCOUNT_NUMBER";

/**
 * Describes the enum billing.v1.AccountSearchField.
 */
export const AccountSearchFieldSchema: GenEnum<AccountSearchField, AccountSearchFieldJson> = /*@__PURE__*/ enumDesc(file_billing_v1_service, 1);

/**
 * @generated from enum billing.v1.SubscriptionState
 */
export enum SubscriptionState {
	/**
	 * @generated from enum value: SUBSCRIPTION_STATE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATE_TRIAL = 1;
	 */
	TRIAL = 1,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATE_PLAN = 2;
	 */
	PLAN = 2,
}

/**
 * @generated from enum billing.v1.SubscriptionState
 */
export type SubscriptionStateJson = "SUBSCRIPTION_STATE_UNSPECIFIED" | "SUBSCRIPTION_STATE_TRIAL" | "SUBSCRIPTION_STATE_PLAN";

/**
 * Describes the enum billing.v1.SubscriptionState.
 */
export const SubscriptionStateSchema: GenEnum<SubscriptionState, SubscriptionStateJson> = /*@__PURE__*/ enumDesc(file_billing_v1_service, 2);

/**
 * @generated from enum billing.v1.InvoiceStatus
 */
export enum InvoiceStatus {
	/**
	 * @generated from enum value: INVOICE_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: INVOICE_STATUS_OPEN = 1;
	 */
	OPEN = 1,

	/**
	 * @generated from enum value: INVOICE_STATUS_PAID = 2;
	 */
	PAID = 2,

	/**
	 * @generated from enum value: INVOICE_STATUS_OVERDUE = 3;
	 */
	OVERDUE = 3,
}

/**
 * @generated from enum billing.v1.InvoiceStatus
 */
export type InvoiceStatusJson = "INVOICE_STATUS_UNSPECIFIED" | "INVOICE_STATUS_OPEN" | "INVOICE_STATUS_PAID" | "INVOICE_STATUS_OVERDUE";

/**
 * Describes the enum billing.v1.InvoiceStatus.
 */
export const InvoiceStatusSchema: GenEnum<InvoiceStatus, InvoiceStatusJson> = /*@__PURE__*/ enumDesc(file_billing_v1_service, 3);

/**
 * @generated from enum billing.v1.WindowSize
 */
export enum WindowSize {
	/**
	 * @generated from enum value: WINDOW_SIZE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: WINDOW_SIZE_HOUR = 1;
	 */
	HOUR = 1,

	/**
	 * @generated from enum value: WINDOW_SIZE_DAY = 2;
	 */
	DAY = 2,

	/**
	 * @generated from enum value: WINDOW_SIZE_WEEK = 3;
	 */
	WEEK = 3,
}

/**
 * @generated from enum billing.v1.WindowSize
 */
export type WindowSizeJson = "WINDOW_SIZE_UNSPECIFIED" | "WINDOW_SIZE_HOUR" | "WINDOW_SIZE_DAY" | "WINDOW_SIZE_WEEK";

/**
 * Describes the enum billing.v1.WindowSize.
 */
export const WindowSizeSchema: GenEnum<WindowSize, WindowSizeJson> = /*@__PURE__*/ enumDesc(file_billing_v1_service, 4);

/**
 * @generated from service billing.v1.BillingService
 */
export const BillingService: GenService<{
	/**
	 * @generated from rpc billing.v1.BillingService.ListSubscriptionsByAccount
	 */
	listSubscriptionsByAccount: {
		methodKind: "unary";
		input: typeof ListSubscriptionsByAccountRequestSchema;
		output: typeof ListSubscriptionsByAccountResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.ListSubscriptions
	 */
	listSubscriptions: {
		methodKind: "unary";
		input: typeof ListSubscriptionsRequestSchema;
		output: typeof ListSubscriptionsResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.ListAccounts
	 */
	listAccounts: {
		methodKind: "unary";
		input: typeof ListAccountsRequestSchema;
		output: typeof ListAccountsResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GetAccount
	 */
	getAccount: {
		methodKind: "unary";
		input: typeof GetAccountRequestSchema;
		output: typeof GetAccountResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GetAdminAccount
	 */
	getAdminAccount: {
		methodKind: "unary";
		input: typeof GetAdminAccountRequestSchema;
		output: typeof GetAdminAccountResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.CreateAccount
	 */
	createAccount: {
		methodKind: "unary";
		input: typeof CreateAccountRequestSchema;
		output: typeof CreateAccountResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GetEntityAccount
	 */
	getEntityAccount: {
		methodKind: "unary";
		input: typeof GetEntityAccountRequestSchema;
		output: typeof GetEntityAccountResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GetSubscription
	 */
	getSubscription: {
		methodKind: "unary";
		input: typeof GetSubscriptionRequestSchema;
		output: typeof GetSubscriptionResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.ListUsageRecords
	 */
	listUsageRecords: {
		methodKind: "unary";
		input: typeof ListUsageRecordsRequestSchema;
		output: typeof ListUsageRecordsResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.ListAdminUsageRecords
	 */
	listAdminUsageRecords: {
		methodKind: "unary";
		input: typeof ListAdminUsageRecordsRequestSchema;
		output: typeof ListAdminUsageRecordsResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.ListInvoices
	 */
	listInvoices: {
		methodKind: "unary";
		input: typeof ListInvoicesRequestSchema;
		output: typeof ListInvoicesResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.DownloadInvoicePDF
	 */
	downloadInvoicePDF: {
		methodKind: "unary";
		input: typeof DownloadInvoicePDFRequestSchema;
		output: typeof DownloadInvoicePDFResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.CreateEntityAccount
	 */
	createEntityAccount: {
		methodKind: "unary";
		input: typeof CreateEntityAccountRequestSchema;
		output: typeof CreateEntityAccountResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.SubscriptionHook
	 */
	subscriptionHook: {
		methodKind: "unary";
		input: typeof SubscriptionHookRequestSchema;
		output: typeof SubscriptionHookResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GetSubscriptionState
	 */
	getSubscriptionState: {
		methodKind: "unary";
		input: typeof GetSubscriptionStateRequestSchema;
		output: typeof GetSubscriptionStateResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GetCurrentSubscription
	 */
	getCurrentSubscription: {
		methodKind: "unary";
		input: typeof GetCurrentSubscriptionRequestSchema;
		output: typeof GetCurrentSubscriptionResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.CreateTrialSubscription
	 */
	createTrialSubscription: {
		methodKind: "unary";
		input: typeof CreateTrialSubscriptionRequestSchema;
		output: typeof CreateTrialSubscriptionResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.ExtendTrial
	 */
	extendTrial: {
		methodKind: "unary";
		input: typeof ExtendTrialRequestSchema;
		output: typeof ExtendTrialResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.CreatePaymentSession
	 */
	createPaymentSession: {
		methodKind: "unary";
		input: typeof CreatePaymentSessionRequestSchema;
		output: typeof CreatePaymentSessionResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.ListPaymentMethods
	 */
	listPaymentMethods: {
		methodKind: "unary";
		input: typeof ListPaymentMethodsRequestSchema;
		output: typeof ListPaymentMethodsResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.UpgradeSubscription
	 */
	upgradeSubscription: {
		methodKind: "unary";
		input: typeof UpgradeSubscriptionRequestSchema;
		output: typeof UpgradeSubscriptionResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.PreviewUpgradeSubscription
	 */
	previewUpgradeSubscription: {
		methodKind: "unary";
		input: typeof PreviewUpgradeSubscriptionRequestSchema;
		output: typeof PreviewUpgradeSubscriptionResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GeneratePaymentSignature
	 */
	generatePaymentSignature: {
		methodKind: "unary";
		input: typeof GeneratePaymentSignatureRequestSchema;
		output: typeof GeneratePaymentSignatureResponseSchema;
	};
	/**
	 * @generated from rpc billing.v1.BillingService.GetUsageSummary
	 */
	getUsageSummary: {
		methodKind: "unary";
		input: typeof GetUsageSummaryRequestSchema;
		output: typeof GetUsageSummaryResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_billing_v1_service, 0);
